<app-modal-shell labelledBy="confirmation-dialog-title">
  <app-modal-header>
    <h2 id="confirmation-dialog-title">{{title}}</h2>
  </app-modal-header>
  <app-modal-body>
    <p>{{message}}</p>
  </app-modal-body>
  <app-modal-footer>
    <button type="button" class="button-secondary" (click)="close()">{{ cancelLabel }}</button>
    <button type="button" [class.button-primary]="!destructive" [class.button-danger]="destructive" (click)="confirm()">{{ confirmLabel }}</button>
  </app-modal-footer>
</app-modal-shell>
